<template>
  <DoughnutChart :chartData="chartData2" :options="options"/>
</template>
<script>
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
import { defineComponent } from "vue";
import { DoughnutChart } from "vue-chart-3";
import tailwindSettings from "../../../tailwind.config";

export default defineComponent({
  name: "Home",
  components: { DoughnutChart },
  data: function () {
    return { masterThreshold: 10, knowThreshold: 6, learnedThreshold: 4 };
  },
  computed: {
    options(){

      const options = {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
      };
      return options;
    },
    cards() {
      let cards = this.$store.state.user.cards;
      cards.forEach((card) => {
        card.score = card.repetition * card.efactor;
      });
      return cards;
    },
    masteredCount() {
      return this.cards.filter((c) => c.score > this.masterThreshold).length;
    },
    learnedCount() {
      return this.cards.filter(
        (c) => c.score > this.learnedThreshold && c.score < this.knowThreshold
      ).length;
    },
    knowCount() {
      return this.cards.filter(
        (c) => c.score > this.knowThreshold && c.score < this.masterThreshold
      ).length;
    },
    practicedCount() {
      return this.cards.filter(
        (c) => c.repetition > 0 && c.score < this.learnedThreshold
      ).length;
    },
    totalCount() {
      return this.cards.lenght;
    },
    newCardsCount() {
      return this.cards.filter((c) => c.repetition == 0).length;
    },
    chartData2() {
      let colors = tailwindSettings.theme.colors;
      let labels = ["new cards", "practiced", "learned", "know", "mastered"];
      let chartColors = [
        colors.error,
        colors.orange,
        colors.warning,
        colors.yellowGreen,
        colors.success,
      ];
      let data = [
        this.newCardsCount,
        this.practicedCount,
        this.learnedCount,
        this.knowCount,
        this.masteredCount,
      ];


      const chartData = {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: chartColors,
          },
        ],
      };
      return chartData;
    },
  },
  setup() {},
});
</script>
